import React, { Component } from 'react';
import { lang } from 'lang';
import { Button, TextInput, Scene, AppHeader, View } from 'core';
import { style } from 'constants';
import * as actions from 'actions';

const styles = style({
  content: {
    alignItems: 'center',
    paddingTop: 20
  },
  button: {
    marginTop: 15
  }
});

class NewGroup extends Component {
  state = {
    title: ''
  };
  render() {
    const { title } = this.state;
    return (
      <Scene>
        <AppHeader title={lang.NEW_GROUP} close />
        <View style={styles.content}>
          <TextInput autoFocus onChangeText={title => this.setState({ title })} placeholder={lang.GROUP_NAME} />
          <Button
            disabled={title.trim() === ''}
            keyboardDismiss
            style={styles.button}
            title={lang.CREATE_GROUP}
            onPress={() => actions.sendGroup({ title })}
            status={this.props.status}
            onSuccess={() => {
              actions.clickCloseModal();
              actions.selectConv();
            }}
          />
        </View>
      </Scene>
    );
  }
}

export default NewGroup;



// WEBPACK FOOTER //
// ./src/components/modals/new_group.js